import { jsx as _jsx } from "react/jsx-runtime";
import { StyledScreenReaderText } from '../../../styles/text';
import { StyledCircularLoader } from './subcomponents';
var CircularLoader = function () {
    return (_jsx(StyledCircularLoader, { "data-testid": "loading-spinner", children: _jsx(StyledScreenReaderText, { children: "Loading..." }) }));
};
export default CircularLoader;
//# sourceMappingURL=index.js.map